export const AGENT_LEADS_ROUTE = '/leads';
export const AGENT_LEADS_PATH = `${AGENT_LEADS_ROUTE}/:lead_id?`;
